import BoxIcon from '@components/Icons/BoxIcon';
import DropboxIcon from '@components/Icons/DropboxIcon';
import FacebookIcon from '@components/Icons/FacebookIcon';
import GoogleDriveIcon from '@components/Icons/GoogleDriveIcon';
import ShadeIcon from '@components/Icons/ShadeIcon';
import SoundCloudIcon from '@components/Icons/SoundCloudIcon';
import TikTokIcon from '@components/Icons/TikTokIcon';
import VimeoIcon from '@components/Icons/VimeoIcon';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import YouTubeIcon from '@mui/icons-material/YouTube';

/** Returns the appropriate icon for a media provider type (as returned by inferProviderType) */
export function getProviderIcon(providerType: string | undefined): React.ReactNode {
  switch (providerType) {
    case 'youtube':
      return <YouTubeIcon fontSize="small" />;
    case 'vimeo':
      return <VimeoIcon />;
    case 'linkedin':
      return <LinkedInIcon fontSize="small" />;
    case 'dropbox':
      return <DropboxIcon />;
    case 'box':
      return <BoxIcon />;
    case 'shade':
      return <ShadeIcon />;
    case 'google-drive':
      return <GoogleDriveIcon />;
    case 'facebook':
      return <FacebookIcon />;
    case 'tiktok':
      return <TikTokIcon />;
    case 'soundcloud':
      return <SoundCloudIcon />;
    default:
      return <OpenInNewIcon fontSize="small" />;
  }
}
